import React from 'react';
import * as S from './InputLabel.styles';
import * as T from './InputLabel.types';

const InputLabel = ({ children, disabled, error, htmlFor, id }: T.InputLabelType) => (
  <S.Label id={id} htmlFor={htmlFor} disabled={disabled} error={error}>
    {children}
  </S.Label>
);

export default InputLabel;
